<template>
  <div>
    <hr />
    <h3>Input Fields</h3>
    <form name="form">
      <div>
        <md-steppers md-vertical>
          <!--Participant Balance-->
          <md-step
            v-if="showInputCategory(INPUT_TYPES.PARTICIPANT_BALANCE)"
            md-label="Participant Balance"
          >
            <div class="md-layout md-gutter">
              <!--Pre Tax-->
              <div class="md-layout-item">
                <md-input-field-with-error
                  v-bind:field="$v.params.participant_balance.pre_tax"
                >
                  <label>Pre Tax</label>
                  <md-input
                    type="number"
                    name="participant_balance_pre_tax"
                    min="0"
                    v-model="params.participant_balance.pre_tax"
                  ></md-input>
                </md-input-field-with-error>
              </div>
              <!--Roth-->
              <div class="md-layout-item">
                <md-input-field-with-error
                  v-bind:field="$v.params.participant_balance.roth"
                >
                  <label>Roth</label>
                  <md-input
                    required
                    type="number"
                    name="participant_balance_roth"
                    v-model="params.participant_balance.roth"
                    min="0"
                  ></md-input>
                </md-input-field-with-error>
              </div>
              <!--Post Tax-->
              <div class="md-layout-item">
                <md-input-field-with-error
                  v-bind:field="$v.params.participant_balance.post_tax"
                >
                  <label>Post Tax</label>
                  <md-input
                    required
                    type="number"
                    name="participant_balance_post_tax"
                    v-model="params.participant_balance.post_tax"
                    min="0"
                  ></md-input>
                </md-input-field-with-error>
              </div>
              <!--Post Tax Basis-->
              <div class="md-layout-item">
                <md-input-field-with-error
                  v-bind:field="$v.params.participant_balance.post_tax_basic"
                >
                  <label>Post Tax Basis</label>
                  <md-input
                    required
                    type="number"
                    name="participant_balance_post_tax_basic"
                    v-model="params.participant_balance.post_tax_basic"
                    min="0"
                  ></md-input>
                </md-input-field-with-error>
              </div>
              <!--ER Match-->
              <div class="md-layout-item">
                <md-input-field-with-error
                  v-bind:field="$v.params.participant_balance.er_match"
                >
                  <label>ER Match</label>
                  <md-input
                    required
                    type="number"
                    name="participant_balance_er_match"
                    v-model="params.participant_balance.er_match"
                    min="0"
                  ></md-input>
                </md-input-field-with-error>
              </div>
              <!--ER Other-->
              <div class="md-layout-item">
                <md-input-field-with-error
                  v-bind:field="$v.params.participant_balance.er_other"
                >
                  <label>ER Other</label>
                  <md-input
                    required
                    type="number"
                    name="participant_balance_er_other"
                    v-model="params.participant_balance.er_other"
                    min="0"
                  ></md-input>
                </md-input-field-with-error>
              </div>
              <!--Rollover-->
              <div class="md-layout-item">
                <md-input-field-with-error
                  v-bind:field="$v.params.participant_balance.rollover"
                >
                  <label>Rollover</label>
                  <md-input
                    required
                    type="number"
                    name="participant_balance_rollover"
                    v-model="params.participant_balance.rollover"
                    min="0"
                  ></md-input>
                </md-input-field-with-error>
              </div>
              <!--Other Pre Tax-->
              <div class="md-layout-item">
                <md-input-field-with-error
                  v-bind:field="$v.params.participant_balance.other_pre_tax"
                >
                  <label>Other Pre Tax</label>
                  <md-input
                    required
                    type="number"
                    name="participant_balance_other_pre_tax"
                    v-model="params.participant_balance.other_pre_tax"
                    min="0"
                  ></md-input>
                </md-input-field-with-error>
              </div>
              <!--Other Roth-->
              <div class="md-layout-item">
                <md-input-field-with-error
                  v-bind:field="$v.params.participant_balance.other_roth"
                >
                  <label>Other Roth</label>
                  <md-input
                    required
                    type="number"
                    name="participant_balance_other_roth"
                    v-model="params.participant_balance.other_roth"
                    min="0"
                  ></md-input>
                </md-input-field-with-error>
              </div>
              <!--Other Post Tax-->
              <div class="md-layout-item">
                <md-input-field-with-error
                  v-bind:field="$v.params.participant_balance.other_post_tax"
                >
                  <label>Other Post Tax</label>
                  <md-input
                    required
                    type="number"
                    name="participant_balance_other_post_tax"
                    v-model="params.participant_balance.other_post_tax"
                    min="0"
                  ></md-input>
                </md-input-field-with-error>
              </div>
            </div>
          </md-step>
          <!--Participant-->
          <md-step
            v-if="showInputCategory(INPUT_TYPES.PARTICIPANT)"
            md-label="Participant"
          >
            <div class="md-layout md-gutter">
              <!--birth_date-->
              <div class="md-layout-item">
                <md-datepicker
                  :class="getValidationClass($v.params.participant.birth_date)"
                  required
                  v-model="params.participant.birth_date"
                >
                  <label>Birth Date</label>
                  <span
                    class="md-error"
                    v-if="$v.params.participant.birth_date.required === false"
                    >You left the field blank.</span
                  >
                </md-datepicker>
              </div>
              <!--hire_date-->
              <div class="md-layout-item">
                <md-datepicker
                  :class="getValidationClass($v.params.participant.hire_date)"
                  required
                  v-model="params.participant.hire_date"
                >
                  <label>Hire Date</label>
                  <span
                    class="md-error"
                    v-if="$v.params.participant.hire_date.required === false"
                    >You left the field blank.</span
                  >
                </md-datepicker>
              </div>
              <!--estimated_annual_wages-->
              <div class="md-layout-item">
                <md-input-field-with-error
                  v-bind:field="$v.params.participant.estimated_annual_wages"
                >
                  <label>Estimated Annual Wages</label>
                  <md-input
                    type="number"
                    name="participant_estimated_annual_wages"
                    required
                    v-model="params.participant.estimated_annual_wages"
                  ></md-input>
                </md-input-field-with-error>
              </div>
              <!--drd_month-->
              <div class="md-layout-item">
                <md-input-field-with-error
                  v-bind:field="$v.params.participant.drd_month"
                >
                  <label>Desired Retirement Month</label>
                  <md-input
                    type="number"
                    v-model="params.participant.drd_month"
                    placeholder="DRD Month"
                  ></md-input>
                </md-input-field-with-error>
              </div>
              <!--drd_year-->
              <div class="md-layout-item">
                <md-input-field-with-error
                  v-bind:field="$v.params.participant.drd_year"
                >
                  <label>Desired Retirement Year</label>
                  <md-input
                    type="number"
                    v-model="params.participant.drd_year"
                    placeholder="DRD Year"
                  ></md-input>
                </md-input-field-with-error>
              </div>
              <!--gender-->
              <div class="md-layout-item">
                <md-input-field-with-error
                  v-bind:field="$v.params.participant.gender"
                >
                  <label>Gender</label>
                  <md-select
                    name="participant_gender"
                    v-model="params.participant.gender"
                    required
                  >
                    <md-option value="m">Male</md-option>
                    <md-option value="f">Female</md-option>
                  </md-select>
                </md-input-field-with-error>
              </div>
              <!--marital_status-->
              <div class="md-layout-item">
                <md-input-field-with-error
                  v-bind:field="$v.params.participant.marital_status"
                >
                  <label>Marital Status</label>
                  <md-select
                    name="participant_marital_status"
                    v-model="params.participant.marital_status"
                    required
                  >
                    <md-option value="single">Single</md-option>
                    <md-option value="married">Married</md-option>
                  </md-select>
                </md-input-field-with-error>
              </div>
              <!--drd_income-->
              <div class="md-layout-item">
                <md-input-field-with-error
                  v-bind:field="$v.params.participant.drd_income"
                >
                  <label>Drd Income</label>
                  <md-input
                    required
                    type="number"
                    name="participant_drd_income"
                    v-model="params.participant.drd_income"
                    min="0"
                  ></md-input>
                </md-input-field-with-error>
              </div>
              <!--pension-->
              <div class="md-layout-item">
                <md-input-field-with-error
                  v-bind:field="$v.params.participant.pension"
                >
                  <label>Pension</label>
                  <md-input
                    type="number"
                    v-model="params.participant.pension"
                  ></md-input>
                </md-input-field-with-error>
              </div>
              <!--state_residence_code-->
              <div class="md-layout-item">
                <md-input-field-with-error
                  v-bind:field="$v.params.participant.state_residence_code"
                >
                  <label>State Residence Code</label>
                  <md-select
                    name="participant_marital_status"
                    v-model="params.participant.state_residence_code"
                    required
                  >
                    <md-option
                      v-for="state in states"
                      v-bind:value="state"
                      v-bind:key="state"
                      >{{ state }}</md-option
                    >
                  </md-select>
                </md-input-field-with-error>
              </div>
              <!--drd_state-->
              <div class="md-layout-item">
                <md-input-field-with-error
                  v-bind:field="$v.params.participant.drd_state"
                >
                  <label>Desired Retirement State</label>
                  <md-select
                    name="participant_marital_status"
                    v-model="params.participant.drd_state"
                  >
                    <md-option
                      v-for="state in states"
                      v-bind:value="state"
                      v-bind:key="state"
                      >{{ state }}</md-option
                    >
                  </md-select>
                </md-input-field-with-error>
              </div>
              <!--Unused-->
              <!--termination_date-->
              <div class="md-layout-item">
                <md-datepicker v-model="params.participant.termination_date">
                  <label>Termination Date</label>
                </md-datepicker>
              </div>
              <!--Unused-->
              <!--social_security_number-->
              <div class="md-layout-item">
                <md-input-field-with-error
                  v-bind:field="$v.params.participant.social_security_number"
                >
                  <label>social_security_number</label>
                  <md-input
                    v-model="params.participant.social_security_number"
                  ></md-input>
                </md-input-field-with-error>
              </div>
              <!--Unused-->
              <!--participant_identifier-->
              <div class="md-layout-item">
                <md-input-field-with-error
                  v-bind:field="$v.params.participant.participant_identifier"
                >
                  <label>participant_identifier</label>
                  <md-input
                    v-model="params.participant.participant_identifier"
                  ></md-input>
                </md-input-field-with-error>
              </div>
              <!--Unused-->
              <!--first_name-->
              <div class="md-layout-item">
                <md-input-field-with-error
                  v-bind:field="$v.params.participant.first_name"
                >
                  <label>first_name</label>
                  <md-input v-model="params.participant.first_name"></md-input>
                </md-input-field-with-error>
              </div>
              <!--Unused-->
              <!--last_name-->
              <div class="md-layout-item">
                <md-input-field-with-error
                  v-bind:field="$v.params.participant.last_name"
                >
                  <label>last_name</label>
                  <md-input v-model="params.participant.last_name"></md-input>
                </md-input-field-with-error>
              </div>
              <!--Unused-->
              <!--first_name-->
              <div class="md-layout-item">
                <md-input-field-with-error
                  v-bind:field="$v.params.participant.first_name"
                >
                  <label>first_name</label>
                  <md-input v-model="params.participant.first_name"></md-input>
                </md-input-field-with-error>
              </div>
              <!--Unused-->
              <!--work_email_address-->
              <div class="md-layout-item">
                <md-input-field-with-error
                  v-bind:field="$v.params.participant.work_email_address"
                >
                  <label>work_email_address</label>
                  <md-input
                    v-model="params.participant.work_email_address"
                  ></md-input>
                </md-input-field-with-error>
              </div>
              <!--Unused-->
              <!--personal_email_address-->
              <div class="md-layout-item">
                <md-input-field-with-error
                  v-bind:field="$v.params.participant.personal_email_address"
                >
                  <label>personal_email_address</label>
                  <md-input
                    v-model="params.participant.personal_email_address"
                  ></md-input>
                </md-input-field-with-error>
              </div>
              <!--Unused-->
              <!--address_1-->
              <div class="md-layout-item">
                <md-input-field-with-error
                  v-bind:field="$v.params.participant.address_1"
                >
                  <label>address_1</label>
                  <md-input v-model="params.participant.address_1"></md-input>
                </md-input-field-with-error>
              </div>
              <!--Unused-->
              <!--address_2-->
              <div class="md-layout-item">
                <md-input-field-with-error
                  v-bind:field="$v.params.participant.address_2"
                >
                  <label>address_2</label>
                  <md-input v-model="params.participant.address_2"></md-input>
                </md-input-field-with-error>
              </div>
              <!--Unused-->
              <!--city-->
              <div class="md-layout-item">
                <md-input-field-with-error
                  v-bind:field="$v.params.participant.city"
                >
                  <label>city</label>
                  <md-input v-model="params.participant.city"></md-input>
                </md-input-field-with-error>
              </div>
              <!--zip_code_id-->
              <!--Unused-->
              <div class="md-layout-item">
                <md-input-field-with-error
                  v-bind:field="$v.params.participant.zip_code_id"
                >
                  <label>zip_code_id</label>
                  <md-input v-model="params.participant.zip_code_id"></md-input>
                </md-input-field-with-error>
              </div>
              <!--hours_per_week-->
              <div class="md-layout-item">
                <!--Unused-->
                <md-input-field-with-error
                  v-bind:field="$v.params.participant.hours_per_week"
                >
                  <label>hours_per_week</label>
                  <md-input
                    v-model="params.participant.hours_per_week"
                  ></md-input>
                </md-input-field-with-error>
              </div>
            </div>
          </md-step>
          <md-step
            v-if="showInputCategory(INPUT_TYPES.PLAN_BASIC_DATA)"
            md-label="Plan Basic Data"
          >
            <div class="md-layout md-gutter">
              <!-- Unused-->
              <!--ein_plan_code-->
              <div class="md-layout-item">
                <md-input-field-with-error
                  v-bind:field="$v.params.plan_basic_data.ein_plan_code"
                >
                  <label>ein_plan_code</label>
                  <md-input
                    required
                    v-model="params.plan_basic_data.ein_plan_code"
                  ></md-input>
                </md-input-field-with-error>
              </div>

              <!-- Unused-->
              <!--plan_number_three_digit-->
              <div class="md-layout-item">
                <md-input-field-with-error
                  v-bind:field="
                    $v.params.plan_basic_data.plan_number_three_digit
                  "
                >
                  <label>plan_number_three_digit</label>
                  <md-input
                    require
                    name="plan_basic_plan_number_three_digit"
                    v-model="params.plan_basic_data.plan_number_three_digit"
                    minlength="3"
                    maxlength="3"
                  ></md-input>
                </md-input-field-with-error>
              </div>
              <div class="md-layout-item">
                <md-datepicker
                  :class="
                    getValidationClass($v.params.plan_basic_data.plan_end_date)
                  "
                  required
                  :md-disabled-dates="onlyLastDayOfMonth"
                  v-model="params.plan_basic_data.plan_end_date"
                  ><label>Plan Year End</label>
                  <span
                    class="md-error"
                    v-if="
                      $v.params.plan_basic_data.plan_end_date.required === false
                    "
                    >You left the field blank.</span
                  >
                </md-datepicker>
              </div>
              <div class="md-layout-item">
                <md-datepicker
                  :class="getValidationClass($v.params.plan_basic_data.date)"
                  name="plan_basic_data_date"
                  required
                  v-model="params.plan_basic_data.date"
                  ><label>Data as of Date</label>
                  <span
                    class="md-error"
                    v-if="$v.params.plan_basic_data.date.required === false"
                    >You left the field blank.</span
                  >
                </md-datepicker>
              </div>
              <div class="md-layout-item">
                <md-input-field-with-error v-bind:field="$v.params.plan_basic_data.is_original"
                >
                  <label>Current Design</label>
                  <md-select
                    name="plan_basic_data_is_original"
                    v-model="params.plan_basic_data.is_original"
                    required
                  >
                    <md-option value="true">Yes</md-option>
                    <md-option value="false">No</md-option>
                  </md-select>
                </md-input-field-with-error>
              </div>
            </div>
          </md-step>
          <md-step
            v-if="showInputCategory(INPUT_TYPES.AUTO_ENROLLMENT)"
            md-label="Auto Enrollment"
          >
            <div class="md-layout md-gutter">
              <!-- Effective date-->
              <div class="md-layout-item">
                <md-datepicker
                    :class="getValidationClass($v.params.auto_enrollment.effective_date)"
                    name="auto_enrollment_effective_date"
                    required
                    v-model="params.auto_enrollment.effective_date"
                ><label>Effective date</label>
<!--                  <span-->
<!--                      class="md-error"-->
<!--                      v-if="$v.params.auto_enrollment.effective_date.required === false"-->
<!--                  >You left the field blank.</span-->
<!--                  >-->
                </md-datepicker>
              </div>
              <!--plan-->
              <div class="md-layout-item">
                <md-input-field-with-error
                  v-bind:field="$v.params.auto_enrollment.plan"
                >
                  <label>Auto Enrollment</label>
                  <md-select
                    name="auto_enrollment_plan"
                    v-model="params.auto_enrollment.plan"
                    required
                  >
                    <md-option value="no">No</md-option>
                    <md-option value="new_hires">New Hires</md-option>
                    <md-option value="all_employees">All Employees</md-option>
                  </md-select>
                </md-input-field-with-error>
              </div>

              <div class="md-layout-item">
                <md-input-field-with-error
                  v-bind:field="$v.params.auto_enrollment.initial_percent"
                >
                  <label>Initial Percent</label>
                  <md-input
                    type="number"
                    name="auto_enrollment_initial_percent"
                    v-model="params.auto_enrollment.initial_percent"
                    min="1"
                    max="15"
                    required
                  ></md-input>
                </md-input-field-with-error>
              </div>

              <div class="md-layout-item">
                <md-input-field-with-error
                  v-bind:field="$v.params.auto_enrollment.type"
                >
                  <label>Auto Enrollment Type</label>
                  <md-select
                    name="auto_enrollment_type"
                    v-model="params.auto_enrollment.type"
                    required
                  >
                    <md-option value="pre_tax">Pre-Tax</md-option>
                    <md-option value="roth">Roth</md-option>
                  </md-select>
                </md-input-field-with-error>
              </div>
            </div>
          </md-step>
          <md-step
            v-if="showInputCategory(INPUT_TYPES.AUTO_INCREASE)"
            md-label="Auto Increase"
          >
            <div class="md-layout md-gutter">
              <div class="md-layout-item">
                <md-datepicker
                    :class="getValidationClass($v.params.auto_increase.effective_date)"
                    name="auto_increase_effective_date"
                    required
                    v-model="params.auto_increase.effective_date"
                ><label>Effective date</label>
                  <!--                  <span-->
                  <!--                      class="md-error"-->
                  <!--                      v-if="$v.params.auto_enrollment.effective_date.required === false"-->
                  <!--                  >You left the field blank.</span-->
                  <!--                  >-->
                </md-datepicker>
              </div>

              <div class="md-layout-item">
                <md-input-field-with-error
                  v-bind:field="$v.params.auto_increase.type"
                >
                  <label>Auto Increase Type</label>
                  <md-select
                    name="auto_increase_type"
                    v-model="params.auto_increase.type"
                    required
                  >
                    <md-option value="no">No</md-option>
                    <md-option value="voluntary">Voluntary</md-option>
                    <md-option value="mandatory">Mandatory</md-option>
                  </md-select>
                </md-input-field-with-error>
              </div>

              <div class="md-layout-item">
                <md-input-field-with-error
                  v-bind:field="$v.params.auto_increase.annual"
                >
                  <label>Annual Percent</label>
                  <md-input
                    name="auto_increase_annual"
                    type="number"
                    v-model="params.auto_increase.annual"
                    min="1"
                    max="15"
                    required
                  ></md-input>
                </md-input-field-with-error>
              </div>

              <div class="md-layout-item">
                <md-input-field-with-error
                  v-bind:field="$v.params.auto_increase.max"
                >
                  <label>Max Percent</label>
                  <md-input
                    name="auto_increase_max"
                    type="number"
                    v-model="params.auto_increase.max"
                    min="1"
                    max="15"
                    required
                  ></md-input>
                </md-input-field-with-error>
              </div>

              <div class="md-layout-item">
                <md-input-field-with-error
                  v-bind:field="$v.params.auto_increase.source"
                >
                  <label>Source</label>
                  <md-select
                    name="auto_increase_source"
                    v-model="params.auto_increase.source"
                    required
                  >
                    <md-option value="pre_tax">Pre-Tax</md-option>
                    <md-option value="roth">Roth</md-option>
                  </md-select>
                </md-input-field-with-error>
              </div>

              <div class="md-layout-item">
                <md-input-field-with-error
                  v-bind:field="$v.params.auto_increase.date_type"
                >
                  <label>Auto Increase Date</label>
                  <md-select
                    name="auto_increase_date_type"
                    v-model="params.auto_increase.date_type"
                    required
                  >
                    <md-option value="A">A</md-option>
                    <md-option value="P">P</md-option>
                    <md-option value="H">H</md-option>
                    <md-option value="E">E</md-option>
                  </md-select>
                </md-input-field-with-error>
              </div>
            </div>
          </md-step>
          <md-step
            v-if="showInputCategory(INPUT_TYPES.EMPLOYEE_CONTRIBUTION)"
            md-label="Employee Contribution"
          >
            <div class="md-layout md-gutter">
              <div class="md-layout-item">
                <md-input-field-with-error
                  v-bind:field="$v.params.employee_contribution.req_age_years"
                >
                  <label>Req age Years</label>
                  <md-input
                    type="number"
                    name="employee_contribution_req_age_years"
                    v-model="params.employee_contribution.req_age_years"
                    min="0"
                    max="21"
                    required
                  ></md-input>
                </md-input-field-with-error>
              </div>

              <div class="md-layout-item">
                <md-input-field-with-error
                  v-bind:field="$v.params.employee_contribution.req_age_months"
                >
                  <label>Req age Month</label>
                  <md-input
                    type="number"
                    name="employee_contribution_req_age_months"
                    v-model="params.employee_contribution.req_age_months"
                    min="0"
                    required
                  ></md-input>
                </md-input-field-with-error>
              </div>

              <div class="md-layout-item">
                <md-input-field-with-error
                  v-bind:field="
                    $v.params.employee_contribution.req_service_months
                  "
                >
                  <label>Req service Month</label>
                  <md-input
                    type="number"
                    name="employee_contribution_req_service_months"
                    v-model="params.employee_contribution.req_service_months"
                    min="0"
                    max="12"
                    required
                  ></md-input>
                </md-input-field-with-error>
              </div>

              <div class="md-layout-item">
                <md-input-field-with-error
                  v-bind:field="$v.params.employee_contribution.entry_date_type"
                >
                  <label>Entry Date Type</label>
                  <md-select
                    name="employee_contribution_entry_date_type"
                    v-model="params.employee_contribution.entry_date_type"
                    required
                  >
                    <md-option value="immediate">Immediate</md-option>
                    <md-option value="monthly">Monthly</md-option>
                    <md-option value="quarterly">Quarterly</md-option>
                    <md-option value="semi_annual">Semi-Annual</md-option>
                  </md-select>
                </md-input-field-with-error>
              </div>

              <div class="md-layout-item">
                <md-input-field-with-error
                  v-bind:field="
                    $v.params.employee_contribution.excluded_employees
                  "
                >
                  <label>Excluded Employees</label>
                  <md-select
                    name="employee_contribution_excluded_employees"
                    v-model="params.employee_contribution.excluded_employees"
                    required
                  >
                    <md-option value="not_used">Not Used</md-option>
                  </md-select>
                </md-input-field-with-error>
              </div>

              <div class="md-layout-item">
                <md-input-field-with-error
                  v-bind:field="$v.params.employee_contribution.pre_tax"
                >
                  <label>Contribution Pre-Tax</label>
                  <md-select
                    name="employee_contribution_pre_tax"
                    v-model="params.employee_contribution.pre_tax"
                    required
                  >
                    <md-option value="yes">Yes</md-option>
                    <md-option value="no">No</md-option>
                  </md-select>
                </md-input-field-with-error>
              </div>
              <div class="md-layout-item md-size-20">
                <md-input-field-with-error
                  v-bind:field="$v.params.employee_contribution.pre_tax_max"
                >
                  <label>Contribution Pre-Tax Max</label>
                  <md-input
                    type="number"
                    name="employee_contribution_pre_tax_max"
                    v-model="params.employee_contribution.pre_tax_max"
                    min="10"
                    max="100"
                    required
                  ></md-input>
                </md-input-field-with-error>
              </div>

              <div class="md-layout-item">
                <md-input-field-with-error
                  v-bind:field="$v.params.employee_contribution.roth"
                >
                  <label>Contribution Roth</label>
                  <md-select
                    name="employee_contribution_roth"
                    v-model="params.employee_contribution.roth"
                    required
                  >
                    <md-option value="yes">Yes</md-option>
                    <md-option value="no">No</md-option>
                  </md-select>
                </md-input-field-with-error>
              </div>
              <div class="md-layout-item">
                <md-input-field-with-error
                  v-bind:field="$v.params.employee_contribution.roth_max"
                >
                  <label>Contribution Roth Max</label>
                  <md-input
                    type="number"
                    name="employee_contribution_roth_max"
                    v-model="params.employee_contribution.roth_max"
                    min="10"
                    max="100"
                    required
                  ></md-input>
                </md-input-field-with-error>
              </div>

              <div class="md-layout-item">
                <md-input-field-with-error
                  v-bind:field="$v.params.employee_contribution.post_tax"
                >
                  <label>Contribution Post-Tax</label>
                  <md-select
                    name="employee_contribution_post_tax"
                    v-model="params.employee_contribution.post_tax"
                    required
                  >
                    <md-option value="yes">Yes</md-option>
                    <md-option value="no">No</md-option>
                  </md-select>
                </md-input-field-with-error>
              </div>

              <div class="md-layout-item">
                <md-input-field-with-error
                  v-bind:field="$v.params.employee_contribution.post_tax_max"
                >
                  <label>Contribution Post-Tax Max</label>
                  <md-input
                    type="number"
                    name="employee_contribution_post_tax_max"
                    v-model="params.employee_contribution.post_tax_max"
                    min="10"
                    max="100"
                    required
                  ></md-input>
                </md-input-field-with-error>
              </div>

              <div class="md-layout-item">
                <md-input-field-with-error
                  v-bind:field="$v.params.employee_contribution.combined"
                >
                  <label>Contribution Combined</label>
                  <md-select
                    name="employee_contribution_combined"
                    v-model="params.employee_contribution.combined"
                    required
                  >
                    <md-option value="yes">Yes</md-option>
                    <md-option value="no">No</md-option>
                  </md-select>
                </md-input-field-with-error>
              </div>

              <div class="md-layout-item">
                <md-input-field-with-error
                  v-bind:field="$v.params.employee_contribution.combined_max"
                >
                  <label>Contribution Combined Maximum</label>
                  <md-input
                    type="number"
                    name="employee_contribution_combined_max"
                    v-model="params.employee_contribution.combined_max"
                    max="100"
                    required
                  ></md-input>
                </md-input-field-with-error>
              </div>

              <div class="md-layout-item">
                <md-input-field-with-error
                  v-bind:field="$v.params.employee_contribution.catch_up"
                >
                  <label>Catch Up</label>
                  <md-select
                    name="employee_contribution_catch_up"
                    v-model="params.employee_contribution.catch_up"
                    required
                  >
                    <md-option value="yes">Yes</md-option>
                    <md-option value="no">No</md-option>
                  </md-select>
                </md-input-field-with-error>
              </div>
            </div>
          </md-step>
          <md-step
            v-if="showInputCategory(INPUT_TYPES.EMPLOYEE_MATCH)"
            md-label="Employee Match"
          >
            <div class="md-layout md-gutter">
              <div class="md-layout-item">
                <md-input-field-with-error
                  v-bind:field="$v.params.employer_match.er_match"
                >
                  <label>Er Match</label>
                  <md-select
                    name="employer_match_er_match"
                    v-model="params.employer_match.er_match"
                    required
                  >
                    <md-option value="yes">Yes</md-option>
                    <md-option value="no">No</md-option>
                  </md-select>
                </md-input-field-with-error>
              </div>

              <div class="md-layout-item">
                <md-input-field-with-error
                  v-bind:field="$v.params.employer_match.type"
                >
                  <label>Type</label>
                  <md-select
                    name="employer_match_type"
                    v-model="params.employer_match.type"
                    required
                  >
                    <md-option value="compensation">Compensation</md-option>
                    <md-option value="contribution">Contribution</md-option>
                  </md-select>
                </md-input-field-with-error>
              </div>

              <div class="md-layout-item">
                <md-input-field-with-error
                  v-bind:field="$v.params.employer_match.req_age_years"
                >
                  <label>Req age Years</label>
                  <md-input
                    type="number"
                    name="employer_match_req_age_years"
                    v-model="params.employer_match.req_age_years"
                    min="0"
                    max="21"
                    required
                  ></md-input>
                </md-input-field-with-error>
              </div>

              <div class="md-layout-item">
                <md-input-field-with-error
                  v-bind:field="$v.params.employer_match.req_age_months"
                >
                  <label>Req age Month</label>
                  <md-input
                    type="number"
                    name="employer_match_req_age_months"
                    v-model="params.employer_match.req_age_months"
                    min="0"
                    required
                  ></md-input>
                </md-input-field-with-error>
              </div>

              <div class="md-layout-item">
                <md-input-field-with-error
                  v-bind:field="$v.params.employer_match.req_service_years"
                >
                  <label>Req service Years</label>
                  <md-input
                    type="number"
                    name="employer_match_req_service_years"
                    v-model="params.employer_match.req_service_years"
                    min="0"
                    max="2"
                    required
                  ></md-input>
                </md-input-field-with-error>
              </div>

              <div class="md-layout-item">
                <md-input-field-with-error
                  v-bind:field="$v.params.employer_match.req_service_months"
                >
                  <label>Req service Month</label>
                  <md-input
                    type="number"
                    name="employer_match_req_service_months"
                    v-model="params.employer_match.req_service_months"
                    min="0"
                    required
                  ></md-input>
                </md-input-field-with-error>
              </div>

              <div class="md-layout-item">
                <md-input-field-with-error
                  v-bind:field="$v.params.employer_match.catch_up_matched"
                >
                  <label>Catch Up Matched</label>
                  <md-select
                    name="employer_match_catch_up_matched"
                    v-model="params.employer_match.catch_up_matched"
                    required
                  >
                    <md-option value="yes">Yes</md-option>
                    <md-option value="no">No</md-option>
                  </md-select>
                </md-input-field-with-error>
              </div>

              <div class="md-layout-item">
                <md-input-field-with-error
                  v-bind:field="$v.params.employer_match.yos_vary"
                >
                  <label>Yos Vary</label>
                  <md-select
                    name="employer_match_yos_vary"
                    v-model="params.employer_match.yos_vary"
                    required
                  >
                    <md-option value="yes">Yes</md-option>
                    <md-option value="no">No</md-option>
                  </md-select>
                </md-input-field-with-error>
              </div>

              <div class="md-layout-item">
                <md-input-field-with-error
                  v-bind:field="$v.params.employer_match.dollar_limit"
                >
                  <label>Dollar Limit</label>
                  <md-select
                    name="employer_match_dollar_limit"
                    v-model="params.employer_match.dollar_limit"
                    required
                  >
                    <md-option value="yes">Yes</md-option>
                    <md-option value="no">No</md-option>
                  </md-select>
                </md-input-field-with-error>
              </div>

              <div class="md-layout-item">
                <md-input-field-with-error
                  v-bind:field="$v.params.employer_match.dollar_limit_amount"
                >
                  <label>Dollar limit amount</label>
                  <md-input
                    name="employer_match_dollar_limit_amount"
                    type="number"
                    v-model="params.employer_match.dollar_limit_amount"
                  ></md-input>
                </md-input-field-with-error>
              </div>

              <div class="md-layout-item">
                <md-input-field-with-error
                  v-bind:field="$v.params.employer_match.funding_frequency"
                >
                  <label>Funding Frequency</label>
                  <md-select
                    name="employer_match_funding_frequency"
                    v-model="params.employer_match.funding_frequency"
                    required
                  >
                    <md-option value="payroll">Payroll</md-option>
                    <md-option value="monthly">Monthly</md-option>
                    <md-option value="quarterly">Quarterly</md-option>
                    <md-option value="semi_annual">Semi Annual</md-option>
                    <md-option value="eoy">EOY</md-option>
                  </md-select>
                </md-input-field-with-error>
              </div>
            </div>

            <div
              v-for="(tier, index) in params.employer_match.tiers"
              :key="`tier-${index}`"
            >
              <div class="md-layout md-gutter md-alignment-center-left">
                <div class="md-layout-item">
                  <md-input-field-with-error
                    v-bind:field="
                      $v.params.employer_match.tiers.$each[index]
                        .matching_amount
                    "
                  >
                    <label>Matching Amount</label>
                    <md-input
                      type="number"
                      v-model="tier.matching_amount"
                      min="0"
                      max="500"
                    ></md-input>
                  </md-input-field-with-error>
                </div>
                <div class="md-layout-item">
                  <md-input-field-with-error
                    v-bind:field="
                      $v.params.employer_match.tiers.$each[index].deferral_rate
                    "
                  >
                    <label>Deferral Rate</label>
                    <md-input
                      type="number"
                      v-model="tier.deferral_rate"
                      min="0"
                      max="15"
                    ></md-input>
                  </md-input-field-with-error>
                </div>
                <div class="md-layout-item">
                  <md-input-field-with-error
                    v-bind:field="
                      $v.params.employer_match.tiers.$each[index]
                        .contribution_amount
                    "
                  >
                    <label>Contribution Amount</label>
                    <md-input
                      type="number"
                      v-model="tier.contribution_amount"
                      min="0"
                      ng-max="complianceLimits.max_deferral"
                    ></md-input>
                  </md-input-field-with-error>
                </div>
                <div class="md-layout-item">
                  <md-input-field-with-error
                    v-bind:field="
                      $v.params.employer_match.tiers.$each[index]
                        .yos_upper_limit
                    "
                  >
                    <label>Yos upper limit</label>
                    <md-input
                      type="number"
                      v-model="tier.yos_upper_limit"
                      min="0"
                      max="30"
                    ></md-input>
                  </md-input-field-with-error>
                </div>
                <md-button
                  class="md-raised md-accent"
                  v-on:click="removeTier(index)"
                  v-if="params.employer_match.tiers.length > 2"
                  >Delete Tier</md-button
                >
              </div>
            </div>
            <md-button
              class="md-raised md-primary"
              v-if="
                !params.employer_match.tiers ||
                  params.employer_match.tiers.length < 5
              "
              v-on:click="addTier()"
              >Add Tier</md-button
            >
          </md-step>
          <md-step
            v-if="showInputCategory(INPUT_TYPES.EMPLOYEE_OTHER)"
            md-label="Employee Other"
          >
            <div class="md-layout md-gutter">
              <div class="md-layout-item">
                <md-input-field-with-error
                  v-bind:field="$v.params.employer_other.er_other"
                >
                  <label>Er Other</label>
                  <md-input
                    type="number"
                    name="employer_other_er_other"
                    v-model="params.employer_other.er_other"
                    required
                    min="0"
                    max="4"
                  ></md-input>
                </md-input-field-with-error>
              </div>

              <div class="md-layout-item">
                <md-input-field-with-error
                  v-bind:field="$v.params.employer_other.req_age_years"
                >
                  <label>Req age Years</label>
                  <md-input
                    type="number"
                    name="employer_other_req_age_years"
                    v-model="params.employer_other.req_age_years"
                    min="0"
                    max="21"
                    required
                  ></md-input>
                </md-input-field-with-error>
              </div>

              <div class="md-layout-item">
                <md-input-field-with-error
                  v-bind:field="$v.params.employer_other.req_age_months"
                >
                  <label>Req age Month</label>
                  <md-input
                    type="number"
                    name="employer_other_req_age_months"
                    v-model="params.employer_other.req_age_months"
                    min="0"
                  ></md-input>
                </md-input-field-with-error>
              </div>

              <div class="md-layout-item">
                <md-input-field-with-error
                  v-bind:field="$v.params.employer_other.req_service_years"
                >
                  <label>Req service Years</label>
                  <md-input
                    type="number"
                    name="employer_other_req_service_years"
                    v-model="params.employer_other.req_service_years"
                    min="0"
                    max="2"
                  ></md-input>
                </md-input-field-with-error>
              </div>

              <div class="md-layout-item">
                <md-input-field-with-error
                  v-bind:field="$v.params.employer_other.req_service_months"
                >
                  <label>Req service Month</label>
                  <md-input
                    type="number"
                    name="employer_other_req_service_months"
                    v-model="params.employer_other.req_service_months"
                    min="0"
                  ></md-input>
                </md-input-field-with-error>
              </div>

              <div class="md-layout-item">
                <md-input-field-with-error
                  v-bind:field="$v.params.employer_other.dollar_limit"
                >
                  <label>Dollar Limit</label>
                  <md-select
                    name="employer_other_dollar_limit"
                    v-model="params.employer_other.dollar_limit"
                    required
                  >
                    <md-option value="yes">Yes</md-option>
                    <md-option value="no">No</md-option>
                  </md-select>
                </md-input-field-with-error>
              </div>

              <div class="md-layout-item">
                <md-input-field-with-error
                  v-bind:field="$v.params.employer_other.dollar_limit_amount"
                >
                  <label>Dollar Limit Amount</label>
                  <md-input
                    type="number"
                    name="employer_other_dollar_limit_amount"
                    v-model="params.employer_other.dollar_limit_amount"
                  ></md-input>
                </md-input-field-with-error>
              </div>

              <div class="md-layout-item">
                <md-input-field-with-error
                  v-bind:field="$v.params.employer_other.flat_dollar_limit"
                >
                  <label>Flat Dollar Limit</label>
                  <md-input
                    type="number"
                    name="employer_other_flat_dollar_limit"
                    v-model="params.employer_other.flat_dollar_limit"
                    min="0"
                  ></md-input>
                </md-input-field-with-error>
              </div>

              <div class="md-layout-item">
                <md-input-field-with-error
                  v-bind:field="$v.params.employer_other.compensation_percent"
                >
                  <label>Compensation Percent</label>
                  <md-input
                    type="number"
                    name="employer_other_compensation_percent"
                    v-model="params.employer_other.compensation_percent"
                    min="0"
                    max="25"
                  ></md-input>
                </md-input-field-with-error>
              </div>

              <div class="md-layout-item">
                <md-input-field-with-error
                  v-bind:field="$v.params.employer_other.compensation_below_lvl"
                >
                  <label>Compensation Below lvl</label>
                  <md-input
                    type="number"
                    name="employer_other_compensation_below_lvl"
                    v-model="params.employer_other.compensation_below_lvl"
                    min="0"
                    max="15"
                  ></md-input>
                </md-input-field-with-error>
              </div>

              <div class="md-layout-item">
                <md-input-field-with-error
                  v-bind:field="$v.params.employer_other.compensation_amount"
                >
                  <label>Compensation Amount</label>
                  <md-input
                    type="number"
                    name="employer_other_compensation_amount"
                    v-model="params.employer_other.compensation_amount"
                  ></md-input>
                </md-input-field-with-error>
              </div>

              <div class="md-layout-item">
                <md-input-field-with-error
                  v-bind:field="$v.params.employer_other.compensation_above_lvl"
                >
                  <label>Compensation Above lvl</label>
                  <md-input
                    type="number"
                    name="employer_other_compensation_above_lvl"
                    v-model="params.employer_other.compensation_above_lvl"
                    min="0"
                    max="15"
                  ></md-input>
                </md-input-field-with-error>
              </div>

              <div class="md-layout-item">
                <md-input-field-with-error
                  v-bind:field="$v.params.employer_other.funding_frequency"
                >
                  <label>Funding Frequency</label>
                  <md-select
                    name="employer_other_funding_frequency"
                    v-model="params.employer_other.funding_frequency"
                    required
                  >
                    <md-option value="payroll">Payroll</md-option>
                    <md-option value="monthly">Monthly</md-option>
                    <md-option value="quarterly">Quarterly</md-option>
                    <md-option value="semi_annual">Semi Annual</md-option>
                    <md-option value="eoy">EOY</md-option>
                  </md-select>
                </md-input-field-with-error>
              </div>
            </div>
          </md-step>
          <md-step
            v-if="showInputCategory(INPUT_TYPES.PRE_TAX_CONTRIBUTION)"
            md-label="Pre Tax Contribution"
          >
            <div class="md-layout md-gutter">
              <div class="md-layout-item">
                <md-input-field-with-error
                  v-bind:field="$v.params.pre_tax_contribution.ytd_dollars"
                >
                  <label>Ytd Dollars</label>
                  <md-input
                    type="number"
                    name="pre_tax_contribution_ytd_dollars"
                    v-model="params.pre_tax_contribution.ytd_dollars"
                  ></md-input>
                </md-input-field-with-error>
              </div>

              <div class="md-layout-item">
                <md-input-field-with-error
                  v-bind:field="$v.params.pre_tax_contribution.percent"
                >
                  <label>Percent</label>
                  <md-input
                    type="number"
                    v-model="params.pre_tax_contribution.percent"
                    max="1"
                  ></md-input>
                </md-input-field-with-error>
              </div>

              <div class="md-layout-item">
                <md-input-field-with-error
                  v-bind:field="$v.params.pre_tax_contribution.dollars"
                >
                  <label>Dollars</label>
                  <md-input
                    type="number"
                    v-model="params.pre_tax_contribution.dollars"
                  ></md-input>
                </md-input-field-with-error>
              </div>

              <div class="md-layout-item">
                <md-input-field-with-error
                  v-bind:field="
                    $v.params.pre_tax_contribution.dollars_frequency
                  "
                >
                  <label>Dollars Frequency</label>
                  <md-select
                    v-model="params.pre_tax_contribution.dollars_frequency"
                    required
                  >
                    <md-option value="12">12</md-option>
                    <md-option value="24">24</md-option>
                    <md-option value="26">26</md-option>
                    <md-option value="52">52</md-option>
                  </md-select>
                </md-input-field-with-error>
              </div>

              <div class="md-layout-item">
                <md-input-field-with-error
                  v-bind:field="
                    $v.params.pre_tax_contribution.ytd_catchup_dollars
                  "
                >
                  <label>Ytd Catchup Dollars</label>
                  <md-input
                    type="number"
                    name="pre_tax_contribution_ytd_catchup_dollars"
                    v-model="params.pre_tax_contribution.ytd_catchup_dollars"
                  ></md-input>
                </md-input-field-with-error>
              </div>

              <div class="md-layout-item">
                <md-input-field-with-error
                  v-bind:field="$v.params.pre_tax_contribution.percent_catchup"
                >
                  <label>Percent Catchup</label>
                  <md-input
                    type="number"
                    v-model="params.pre_tax_contribution.percent_catchup"
                  ></md-input>
                </md-input-field-with-error>
              </div>

              <div class="md-layout-item">
                <md-input-field-with-error
                  v-bind:field="$v.params.pre_tax_contribution.dollars_catchup"
                >
                  <label>Dollars Catchup</label>
                  <md-input
                    type="number"
                    name="pre_tax_contribution_dollars_catchup"
                    v-model="params.pre_tax_contribution.dollars_catchup"
                  ></md-input>
                </md-input-field-with-error>
              </div>

              <div class="md-layout-item">
                <md-input-field-with-error
                  v-bind:field="
                    $v.params.pre_tax_contribution.dollars_catchup_frequency
                  "
                >
                  <label>Dollars Catchup Frequency</label>
                  <md-select
                    v-model="
                      params.pre_tax_contribution.dollars_catchup_frequency
                    "
                    required
                  >
                    <md-option value="12">12</md-option>
                    <md-option value="24">24</md-option>
                    <md-option value="26">26</md-option>
                    <md-option value="52">52</md-option>
                  </md-select>
                </md-input-field-with-error>
              </div>

              <div class="md-layout-item">
                <md-input-field-with-error
                  v-bind:field="$v.params.pre_tax_contribution.opt_out"
                >
                  <label>opt out pre tax</label>
                  <md-select
                    v-model="params.pre_tax_contribution.opt_out"
                    required
                  >
                    <md-option value="yes">Yes</md-option>
                    <md-option value="no">No</md-option>
                  </md-select>
                </md-input-field-with-error>
              </div>

              <div class="md-layout-item">
                <md-datepicker
                    :class="getValidationClass($v.params.pre_tax_contribution.effective_date)"
                    name="pre_tax_contribution_effective_date"
                    required
                    v-model="params.pre_tax_contribution.effective_date"
                ><label>Effective date</label>
                </md-datepicker>
              </div>

              <div class="md-layout-item">
                <md-input-field-with-error
                  v-bind:field="$v.params.pre_tax_contribution.frequency_type"
                >
                  <label>Frequency Type</label>
                  <md-select
                    v-model="params.pre_tax_contribution.frequency_type"
                    required
                  >
                    <md-option value="no">No</md-option>
                    <md-option value="S">S</md-option>
                    <md-option value="A">A</md-option>
                    <md-option value="C">C</md-option>
                    <md-option value="P">P</md-option>
                    <md-option value="H">H</md-option>
                    <md-option value="E">E</md-option>
                  </md-select>
                </md-input-field-with-error>
              </div>

              <div class="md-layout-item">
                <md-input-field-with-error
                  v-bind:field="$v.params.pre_tax_contribution.annual_percent"
                >
                  <label>Annual Percent</label>
                  <md-input
                    type="number"
                    v-model="params.pre_tax_contribution.annual_percent"
                    min="0"
                    max="5"
                  ></md-input>
                </md-input-field-with-error>
              </div>

              <div class="md-layout-item">
                <md-input-field-with-error
                  v-bind:field="$v.params.pre_tax_contribution.maximum_percent"
                >
                  <label>Maximum Percent</label>
                  <md-input
                    type="number"
                    v-model="params.pre_tax_contribution.maximum_percent"
                    min="0"
                    max="5"
                  ></md-input>
                </md-input-field-with-error>
              </div>

              <div class="md-layout-item">
                <md-input-field-with-error
                    v-bind:field="$v.params.pre_tax_contribution.annual_date"
                >
                  <label>Annual Date</label>
                  <md-input
                      type="text"
                      v-model="params.pre_tax_contribution.annual_date"
                  ></md-input>
                </md-input-field-with-error>
              </div>

              <div class="md-layout-item">
                <md-input-field-with-error
                  v-bind:field="$v.params.pre_tax_contribution.frequency1"
                >
                  <label>Frequency 1</label>
                  <md-input
                    type="text"
                    v-model="params.pre_tax_contribution.frequency1"
                  ></md-input>
                </md-input-field-with-error>
              </div>

              <div class="md-layout-item">
                <md-input-field-with-error
                  v-bind:field="$v.params.pre_tax_contribution.frequency2"
                >
                  <label>Frequency 2</label>
                  <md-input
                    type="text"
                    v-model="params.pre_tax_contribution.frequency2"
                  ></md-input>
                </md-input-field-with-error>
              </div>
              <div class="md-layout-item"></div>
            </div>
          </md-step>
          <md-step
            v-if="showInputCategory(INPUT_TYPES.ROTH_CONTRIBUTION)"
            md-label="Roth Contribution"
          >
            <div class="md-layout md-gutter">
              <div class="md-layout-item">
                <md-input-field-with-error
                  v-bind:field="$v.params.roth_contribution.ytd_dollars"
                >
                  <label>Ytd Dollars</label>
                  <md-input
                    type="number"
                    name="roth_contribution_ytd_dollars"
                    v-model="params.roth_contribution.ytd_dollars"
                  ></md-input>
                </md-input-field-with-error>
              </div>

              <div class="md-layout-item">
                <md-input-field-with-error
                  v-bind:field="$v.params.roth_contribution.percent"
                >
                  <label>Percent</label>
                  <md-input
                    type="number"
                    v-model="params.roth_contribution.percent"
                    max="1"
                  ></md-input>
                </md-input-field-with-error>
              </div>

              <div class="md-layout-item">
                <md-input-field-with-error
                  v-bind:field="$v.params.roth_contribution.dollars"
                >
                  <label>Dollars</label>
                  <md-input
                    type="number"
                    v-model="params.roth_contribution.dollars"
                  ></md-input>
                </md-input-field-with-error>
              </div>

              <div class="md-layout-item">
                <md-input-field-with-error
                  v-bind:field="$v.params.roth_contribution.dollars_frequency"
                >
                  <label>Dollars Frequency</label>
                  <md-select
                    v-model="params.roth_contribution.dollars_frequency"
                    required
                  >
                    <md-option value="12">12</md-option>
                    <md-option value="24">24</md-option>
                    <md-option value="26">26</md-option>
                    <md-option value="52">52</md-option>
                  </md-select>
                </md-input-field-with-error>
              </div>

              <div class="md-layout-item">
                <md-input-field-with-error
                  v-bind:field="$v.params.roth_contribution.ytd_catchup_dollars"
                >
                  <label>Ytd Catchup Dollars</label>
                  <md-input
                    type="number"
                    name="roth_contribution_ytd_catchup_dollars"
                    v-model="params.roth_contribution.ytd_catchup_dollars"
                  ></md-input>
                </md-input-field-with-error>
              </div>

              <div class="md-layout-item">
                <md-input-field-with-error
                  v-bind:field="$v.params.roth_contribution.percent_catchup"
                >
                  <label>Percent Catchup</label>
                  <md-input
                    type="number"
                    v-model="params.roth_contribution.percent_catchup"
                  ></md-input>
                </md-input-field-with-error>
              </div>

              <div class="md-layout-item">
                <md-input-field-with-error
                  v-bind:field="$v.params.roth_contribution.dollars_catchup"
                >
                  <label>Dollars Catchup</label>
                  <md-input
                    type="number"
                    name="roth_contribution_dollars_catchup"
                    v-model="params.roth_contribution.dollars_catchup"
                  ></md-input>
                </md-input-field-with-error>
              </div>

              <div class="md-layout-item">
                <md-input-field-with-error
                  v-bind:field="
                    $v.params.roth_contribution.dollars_catchup_frequency
                  "
                >
                  <label>Dollars Catchup Frequency</label>
                  <md-select
                    v-model="params.roth_contribution.dollars_catchup_frequency"
                    required
                  >
                    <md-option value="12">12</md-option>
                    <md-option value="24">24</md-option>
                    <md-option value="26">26</md-option>
                    <md-option value="52">52</md-option>
                  </md-select>
                </md-input-field-with-error>
              </div>

              <div class="md-layout-item">
                <md-input-field-with-error
                  v-bind:field="$v.params.roth_contribution.opt_out"
                >
                  <label>opt out rotj</label>
                  <md-select
                    v-model="params.roth_contribution.opt_out"
                    required
                  >
                    <md-option value="yes">Yes</md-option>
                    <md-option value="no">No</md-option>
                  </md-select>
                </md-input-field-with-error>
              </div>

              <div class="md-layout-item">
                <md-datepicker
                    :class="getValidationClass($v.params.roth_contribution.effective_date)"
                    name="roth_contribution_effective_date"
                    required
                    v-model="params.roth_contribution.effective_date"
                ><label>Effective date</label>
                </md-datepicker>
              </div>

              <div class="md-layout-item">
                <md-input-field-with-error
                  v-bind:field="$v.params.roth_contribution.frequency_type"
                >
                  <label>Frequency Type</label>
                  <md-select v-model="params.roth_contribution.frequency_type">
                    <md-option value="no">No</md-option>
                    <md-option value="S">S</md-option>
                    <md-option value="C">C</md-option>
                    <md-option value="A">A</md-option>
                    <md-option value="P">P</md-option>
                    <md-option value="H">H</md-option>
                    <md-option value="E">E</md-option>
                  </md-select>
                </md-input-field-with-error>
              </div>

              <div class="md-layout-item md-size-20">
                <md-input-field-with-error
                  v-bind:field="$v.params.roth_contribution.annual_percent"
                >
                  <label>Annual Percent</label>
                  <md-input
                    type="number"
                    v-model="params.roth_contribution.annual_percent"
                    min="0"
                    max="5"
                  ></md-input>
                </md-input-field-with-error>
              </div>

              <div class="md-layout-item md-size-20">
                <md-input-field-with-error
                  v-bind:field="$v.params.roth_contribution.maximum_percent"
                >
                  <label>Maximum Percent</label>
                  <md-input
                    type="number"
                    v-model="params.roth_contribution.maximum_percent"
                    min="0"
                    max="5"
                  ></md-input>
                </md-input-field-with-error>
              </div>

              <div class="md-layout-item">
                <md-input-field-with-error
                    v-bind:field="$v.params.roth_contribution.annual_date"
                >
                  <label>Annual Date</label>
                  <md-input
                      type="text"
                      v-model="params.roth_contribution.annual_date"
                  ></md-input>
                </md-input-field-with-error>
              </div>

              <div class="md-layout-item">
                <md-input-field-with-error
                  v-bind:field="$v.params.roth_contribution.frequency1"
                >
                  <label>Frequency 1</label>
                  <md-input
                    type="text"
                    v-model="params.roth_contribution.frequency1"
                  ></md-input>
                </md-input-field-with-error>
              </div>

              <div class="md-layout-item">
                <md-input-field-with-error
                  v-bind:field="$v.params.roth_contribution.frequency2"
                >
                  <label>Frequency 2</label>
                  <md-input
                    type="text"
                    v-model="params.roth_contribution.frequency2"
                  ></md-input>
                </md-input-field-with-error>
              </div>
            </div>
          </md-step>
          <md-step
            v-if="showInputCategory(INPUT_TYPES.POST_TAX_CONTRIBUTION)"
            md-label="Post Tax Contribution"
          >
            <div class="md-layout md-gutter">
              <div class="md-layout-item">
                <md-input-field-with-error
                  v-bind:field="$v.params.post_tax_contribution.ytd_dollars"
                >
                  <label>Ytd Dollars</label>
                  <md-input
                    type="number"
                    name="post_tax_contribution_ytd_dollars"
                    v-model="params.post_tax_contribution.ytd_dollars"
                  ></md-input>
                </md-input-field-with-error>
              </div>

              <div class="md-layout-item">
                <md-input-field-with-error
                  v-bind:field="$v.params.post_tax_contribution.dollars"
                >
                  <label>Dollars</label>
                  <md-input
                    type="number"
                    v-model="params.post_tax_contribution.dollars"
                  ></md-input>
                </md-input-field-with-error>
              </div>

              <div class="md-layout-item">
                <md-input-field-with-error
                  v-bind:field="
                    $v.params.post_tax_contribution.dollars_frequency
                  "
                >
                  <label>Dollars Frequency</label>
                  <md-select
                    name="post_tax_contribution_dollars_frequency"
                    v-model="params.post_tax_contribution.dollars_frequency"
                    required
                  >
                    <md-option value="12">12</md-option>
                    <md-option value="24">24</md-option>
                    <md-option value="26">26</md-option>
                    <md-option value="52">52</md-option>
                  </md-select>
                </md-input-field-with-error>
              </div>

              <!--Unused-->
              <div class="md-layout-item">
                <md-input-field-with-error
                  v-bind:field="$v.params.post_tax_contribution.percent"
                >
                  <label>Percent</label>
                  <md-input
                    type="number"
                    v-model="params.post_tax_contribution.percent"
                    max="1"
                  ></md-input>
                </md-input-field-with-error>
              </div>

              <!--Unused-->
              <div class="md-layout-item md-size-25">
                <md-input-field-with-error
                  v-bind:field="$v.params.er_matching_contribution_ytd_dollars"
                >
                  <label>er_matching_contribution_ytd_dollars</label>
                  <md-input
                    type="number"
                    name="er_matching_contribution_ytd_dollars"
                    v-model="params.er_matching_contribution_ytd_dollars"
                  ></md-input>
                </md-input-field-with-error>
              </div>

              <!--Unused-->
              <div class="md-layout-item">
                <md-input-field-with-error
                  v-bind:field="$v.params.er_other_contribution_ytd_dollars"
                >
                  <label>er_other_contribution_ytd_dollars</label>
                  <md-input
                    type="number"
                    name="er_other_contribution_ytd_dollars"
                    v-model="params.er_other_contribution_ytd_dollars"
                  ></md-input>
                </md-input-field-with-error>
              </div>
            </div>
          </md-step>
          <md-step
            v-if="showInputCategory(INPUT_TYPES.NQDC_CONTRIBUTION)"
            md-label="NQDC Contribution"
          >
            <div class="md-layout md-gutter">
              <div class="md-layout-item">
                <md-input-field-with-error
                  v-bind:field="$v.params.nqdc.ytd_dollars"
                >
                  <label>Ytd Dollars</label>
                  <md-input
                    type="number"
                    v-model="params.nqdc.ytd_dollars"
                  ></md-input>
                </md-input-field-with-error>
              </div>

              <div class="md-layout-item">
                <md-input-field-with-error
                  v-bind:field="$v.params.nqdc.percent"
                >
                  <label>Percent</label>
                  <md-input
                    type="number"
                    name="nqdc_percent"
                    v-model="params.nqdc.percent"
                    max="1"
                  ></md-input>
                </md-input-field-with-error>
              </div>

              <div class="md-layout-item">
                <md-input-field-with-error
                  v-bind:field="$v.params.nqdc.dollars"
                >
                  <label>Dollars</label>
                  <md-input
                    type="number"
                    v-model="params.nqdc.dollars"
                  ></md-input>
                </md-input-field-with-error>
              </div>

              <div class="md-layout-item">
                <md-input-field-with-error
                  v-bind:field="$v.params.nqdc.balance"
                >
                  <label>Balance</label>
                  <md-input
                    type="number"
                    v-model="params.nqdc.balance"
                  ></md-input>
                </md-input-field-with-error>
              </div>

              <div class="md-layout-item">
                <md-input-field-with-error
                  v-bind:field="$v.params.nqdc.dollars_frequency"
                >
                  <label>Dollars Frequency</label>
                  <md-select
                    name="nqdc_dollars_frequency"
                    v-model="params.nqdc.dollars_frequency"
                    required
                  >
                    <md-option value="12">12</md-option>
                    <md-option value="24">24</md-option>
                    <md-option value="26">26</md-option>
                    <md-option value="52">52</md-option>
                  </md-select>
                </md-input-field-with-error>
              </div>
              <div class="md-layout-item">
                <md-input-field-with-error
                  v-bind:field="$v.params.nqdc.pension"
                >
                  <label>Pension</label>
                  <md-input
                    type="number"
                    v-model="params.nqdc.pension"
                  ></md-input>
                </md-input-field-with-error>
              </div>
            </div>
          </md-step>
          <md-step
            v-if="showInputCategory(INPUT_TYPES.COMPLIANCE_LIMIT)"
            md-label="Compliance Limit"
          >
            <div class="md-layout md-gutter">
              <div class="md-layout-item">
                <md-input-field-with-error
                  v-bind:field="$v.params.compliance_limit.max_deferral"
                >
                  <label>Max deferral</label>
                  <md-input
                    type="number"
                    v-model="params.compliance_limit.max_deferral"
                  ></md-input>
                </md-input-field-with-error>
              </div>

              <!-- Unused -->
              <div class="md-layout-item">
                <md-input-field-with-error
                  v-bind:field="
                    $v.params.compliance_limit.max_contribution_dc_plan
                  "
                >
                  <label>Max Contribution dc plan </label>
                  <md-input
                    type="number"
                    v-model="params.compliance_limit.max_contribution_dc_plan"
                  ></md-input>
                </md-input-field-with-error>
              </div>

              <!-- Unused -->
              <div class="md-layout-item">
                <md-input-field-with-error
                  v-bind:field="
                    $v.params.compliance_limit.max_contribution_db_plan
                  "
                >
                  <label>Max Contribution db plan </label>
                  <md-input
                    type="number"
                    v-model="params.compliance_limit.max_contribution_db_plan"
                  ></md-input>
                </md-input-field-with-error>
              </div>

              <div class="md-layout-item">
                <md-input-field-with-error
                  v-bind:field="$v.params.compliance_limit.max_comp"
                >
                  <label>Max Comp</label>
                  <md-input
                    type="number"
                    v-model="params.compliance_limit.max_comp"
                  ></md-input>
                </md-input-field-with-error>
              </div>

              <div class="md-layout-item">
                <md-input-field-with-error
                  v-bind:field="$v.params.compliance_limit.catch_up"
                >
                  <label>Catch Up</label>
                  <md-input
                    type="number"
                    v-model="params.compliance_limit.catch_up"
                  ></md-input>
                </md-input-field-with-error>
              </div>

              <!-- Unused -->
              <div class="md-layout-item">
                <md-input-field-with-error
                  v-bind:field="$v.params.compliance_limit.hce_comp"
                >
                  <label>Hce Comp</label>
                  <md-input
                    type="number"
                    v-model="params.compliance_limit.hce_comp"
                  ></md-input>
                </md-input-field-with-error>
              </div>

              <!-- Unused -->
              <div class="md-layout-item">
                <md-input-field-with-error
                  v-bind:field="$v.params.compliance_limit.key_ee_comp_officer"
                >
                  <label>key_ee_comp_officer</label>
                  <md-input
                    type="number"
                    v-model="params.compliance_limit.key_ee_comp_officer"
                  ></md-input>
                </md-input-field-with-error>
              </div>

              <!-- Unused -->
              <div class="md-layout-item">
                <md-input-field-with-error
                  v-bind:field="
                    $v.params.compliance_limit.one_percent_owner_comp
                  "
                >
                  <label>one_percent_owner_comp</label>
                  <md-input
                    type="number"
                    v-model="params.compliance_limit.one_percent_owner_comp"
                  ></md-input>
                </md-input-field-with-error>
              </div>

              <!-- Unused -->
              <div class="md-layout-item">
                <md-input-field-with-error
                  v-bind:field="
                    $v.params.compliance_limit.social_security_wage_base
                  "
                >
                  <label>social_security_wage_base</label>
                  <md-input
                    type="number"
                    v-model="params.compliance_limit.social_security_wage_base"
                  ></md-input>
                </md-input-field-with-error>
              </div>
              <div class="md-layout-item"></div>
            </div>
          </md-step>
        </md-steppers>
      </div>
      <md-button
        class="md-raised md-primary"
        :disabled="$v.$invalid"
        @click="calculate()"
        >Calculate</md-button
      >
    </form>
  </div>
</template>

<script>
import { FETCH_COMPLIANCE_LIMITS } from "@/store/actions.type";
import { mapGetters } from "vuex";
import { validationMixin } from "vuelidate";
import {
  required,
  minValue,
  maxValue,
  minLength,
  maxLength
} from "vuelidate/lib/validators";
import { INPUT_TYPES } from "@/store/calculatorInputs.type";
import MdInputFieldWithError from "./InputFieldWithError";
export default {
  name: "RoeCalcInputFields",
  props: {
    calcAction: {
      type: String,
      required: true
    },
    inputCategories: {
      type: Array,
      required: true
    }
  },
  components: { MdInputFieldWithError },
  data() {
    return {
      INPUT_TYPES: INPUT_TYPES,
      params: {
        plan_basic_data: {
          ein_plan_code: "12-3456789",
          plan_number_three_digit: "001",
          plan_end_date: new Date("2020/7/1Z"),
          date: new Date("2020/4/1Z"),
          is_original: true
        },
        participant: {
          estimated_annual_wages: 75000,
          birth_date: new Date("1968/7/20Z"),
          hire_date: new Date("2019/5/3Z"),
          drd_year: null,
          drd_month: null,
          gender: "m",
          marital_status: "single",
          drd_income: 0,
          pension: 100,
          state_residence_code: "AZ",
          drd_state: "PA",
          social_security_number: "123-45-6789",
          participant_identifier: "ABCDEF123456789",
          first_name: "William",
          last_name: "Smith",
          work_email_address: "wsmith@abco.com",
          personal_email_address: "willsmith24@gmail.com",
          address_1: "123 Main Street",
          address_2: "",
          city: "Scottsdale",
          zip_code_id: "85262",
          hours_per_week: 40
        },
        employee_contribution: {
          req_age_years: 20,
          req_age_months: 6,
          req_service_months: 10,
          entry_date_type: "monthly",
          excluded_employees: "not_used",
          pre_tax: "yes",
          pre_tax_max: 0.25,
          roth: "yes",
          roth_max: 0.25,
          post_tax: "yes",
          post_tax_max: 0.25,
          combined: "yes",
          combined_max: 0.75,
          catch_up: "yes"
        },
        employer_match: {
          funding_frequency: "eoy",
          er_match: "yes",
          post_tax_contributions: "yes",
          req_age_years: 20,
          req_age_months: 6,
          req_service_years: 2,
          req_service_months: 0,
          catch_up_matched: "yes",
          yos_vary: "no",
          yos_vary_ee: "no",
          true_up: "yes",
          tiers: [
            {
              matching_amount: 1,
              deferral_rate: 0.03,
              contribution_amount: 0
            },
            {
              matching_amount: 1,
              deferral_rate: 0.04,
              contribution_amount: 0
            },
            {
              matching_amount: 1,
              deferral_rate: 0.05
            },
            {
              matching_amount: 1,
              deferral_rate: 0.06,
              contribution_amount: 0
            },
            {
              matching_amount: 1,
              deferral_rate: 0.07,
              contribution_amount: 0
            },
            {
              matching_amount: 1,
              deferral_rate: 0.08,
              contribution_amount: 0
            }
          ],
          dollar_limit: "no",
          dollar_limit_amount: 0,
          type: "compensation"
        },
        employer_other: {
          funding_frequency: "eoy",
          er_other: 1,
          compensation_percent: 5,
          flat_dollar_limit: 3750,
          dollar_limit_amount: 6000,
          compensation_amount: 128700,
          compensation_below_lvl: 5.7,
          compensation_above_lvl: 11.4,
          dollar_limit: "yes",
          req_age_years: 21,
          req_age_months: 0,
          req_service_years: 1,
          req_service_months: 9
        },
        pre_tax_contribution: {
          type: 'pre_tax',
          ytd_dollars: 0,
          percent: 0.02,
          dollars: 0,
          dollars_frequency: "24",
          ytd_catchup_dollars: 0,
          percent_catchup: 0.04,
          dollars_catchup: 0,
          dollars_catchup_frequency: "24",
          opt_out: "no",
          effective_date: new Date("2021/1/2Z"),
          frequency_type: "C",
          annual_percent: 0.01,
          maximum_percent: 0.05,
          annual_date: "1014",
          frequency1: "0525",
          frequency2: "0704"
        },
        roth_contribution: {
          type: 'roth',
          ytd_dollars: 0.0,
          percent: 0,
          dollars: 100,
          dollars_frequency: "24",
          ytd_catchup_dollars: 0,
          percent_catchup: 0,
          dollars_catchup: 0,
          dollars_catchup_frequency: "24",
          opt_out: "no",
          effective_date: new Date("2022/7/2Z"),
          frequency_type: "A",
          annual_percent: 0.01,
          maximum_percent: 0.04,
          annual_date: "1105",
          frequency1: "0630",
          frequency2: "0726"
        },
        auto_enrollment: {
          effective_date: new Date("2018/1/2Z"),
          plan: "new_hires",
          initial_percent: 0.06,
          type: "pre_tax"
        },
        auto_increase: {
          effective_date: new Date("2020/10/2Z"),
          type: "mandatory",
          source: "pre_tax",
          annual: 0.01,
          max: 0.12,
          date_type: "P"
        },
        compliance_limit: {
          max_deferral: 19500,
          catch_up: 6500,
          max_comp: 285000,
          max_contribution_dc_plan: 57000,
          max_contribution_db_plan: 230000,
          hce_comp: 130000,
          key_ee_comp_officer: 185000,
          one_percent_owner_comp: 150000,
          social_security_wage_base: 137700
        },
        post_tax_contribution: {
          type: 'post_tax',
          ytd_dollars: 0,
          percent: 0.005,
          dollars: 0,
          dollars_frequency: "24",
          effective_date: new Date("2022/7/2Z"),
          frequency_type: "E",
          annual_percent: 0.005,
          maximum_percent: 0.02,
          annual_date: "1215",
          frequency1: "0630",
          frequency2: "0726"
        },
        er_match_contribution: {
          ytd_dollars: 0
        },
        nqdc: {
          ytd_dollars: 300,
          percent: 1,
          dollars: 0,
          dollars_frequency: "24",
          balance: 12500,
          pension: 50
        },
        participant_balance: {
          pre_tax: 0,
          roth: 0,
          post_tax: 0,
          post_tax_basic: 0,
          er_match: 0,
          er_other: 0,
          rollover: 0,
          other_pre_tax: 0,
          other_roth: 0,
          other_post_tax: 0
        },
        er_other_contribution_ytd_dollars: 1000,
        participant_part_time_income: {
          amount_exists: "yes",
          start_age: 65,
          end_age: 70,
          monthly_amount: 500
        }
      },
      states: [
        "AK",
        "AL",
        "AR",
        "AZ",
        "CA",
        "CO",
        "CT",
        "DC",
        "DE",
        "FL",
        "GA",
        "HI",
        "IA",
        "ID",
        "IL",
        "IN",
        "KS",
        "KY",
        "LA",
        "MA",
        "MD",
        "ME",
        "MI",
        "MN",
        "MO",
        "MS",
        "MT",
        "NC",
        "ND",
        "NE",
        "NH",
        "NJ",
        "NM",
        "NV",
        "NY",
        "OH",
        "OK",
        "OR",
        "PA",
        "RI",
        "SC",
        "SD",
        "TN",
        "TX",
        "UT",
        "VA",
        "VT",
        "WA",
        "WI",
        "WV",
        "WY"
      ],
      onlyLastDayOfMonth: date => {
        return (
          date.toDateString() !==
          new Date(date.getFullYear(), date.getMonth() + 1, 0).toDateString()
        );
      }
    };
  },
  mixins: [validationMixin],
  validations() {
    return {
      params: {
        participant_balance: {
          pre_tax: { required, minValue: minValue(0) },
          roth: { required, minValue: minValue(0) },
          post_tax: {
            required,
            minValue: minValue(0)
          },
          post_tax_basic: {
            required,
            minValue: minValue(0)
          },
          er_match: {
            required,
            minValue: minValue(0)
          },
          er_other: {
            required,
            minValue: minValue(0)
          },
          rollover: {
            required,
            minValue: minValue(0)
          },
          other_pre_tax: {
            required,
            minValue: minValue(0)
          },
          other_roth: {
            required,
            minValue: minValue(0)
          },
          other_post_tax: {
            required,
            minValue: minValue(0)
          }
        },
        participant: {
          birth_date: { required },
          hire_date: { required },
          estimated_annual_wages: { required, minValue: minValue(0) },
          drd_month: { minValue: minValue(0), maxValue: maxValue(12) },
          drd_year: {},
          gender: { required },
          marital_status: { required },
          drd_income: { minValue: minValue(0) },
          pension: { required },
          state_residence_code: { required },
          drd_state: {},
          termination_date: {},
          participant_identifier: {},
          first_name: {},
          last_name: {},
          work_email_address: {},
          personal_email_address: {},
          address_1: {},
          address_2: {},
          city: {},
          zip_code_id: {},
          hours_per_week: {}
        },
        plan_basic_data: {
          ein_plan_code: { required },
          plan_number_three_digit: {
            required,
            minLength: minLength(3),
            maxLength: maxLength(3)
          },
          plan_end_date: { required },
          date: { required }
        },
        auto_enrollment: {
          plan: { required },
          initial_percent: {
            required,
            minValue: minValue(0.01),
            maxValue: maxValue(0.15)
          },
          type: { required }
        },
        auto_increase: {
          type: { required },
          annual: { required, minValue: minValue(0.01), maxValue: maxValue(0.15) },
          max: { required, minValue: minValue(0.01), maxValue: maxValue(0.15) },
          source: { required },
          date_type: { required }
        },
        employee_contribution: {
          req_age_years: {
            required,
            minValue: minValue(0),
            maxValue: maxValue(21)
          },
          req_age_months: {
            required,
            minValue: minValue(0),
            maxValue: maxValue(
              this.reqAgeMonthMax(
                this.params.employee_contribution.req_age_years,
                21
              )
            )
          },
          req_service_months: {
            required,
            minValue: minValue(0),
            maxValue: maxValue(12)
          },
          entry_date_type: { required },
          excluded_employees: { required },
          pre_tax: { required },
          pre_tax_max: {
            required,
            minValue: minValue(0.1),
            maxValue: maxValue(1)
          },
          roth: { required },
          roth_max: {
            required,
            minValue: minValue(0.1),
            maxValue: maxValue(1)
          },
          post_tax: { required },
          post_tax_max: {
            required,
            minValue: minValue(0.1),
            maxValue: maxValue(1)
          },
          combined: { required },
          combined_max: {
            required,
            minValue: minValue(this.combinedMax()),
            maxValue: maxValue(1)
          },
          catch_up: { required }
        },
        employer_match: {
          er_match: { required },
          type: { required },
          req_age_years: {
            required,
            minValue: minValue(0),
            maxValue: maxValue(21)
          },
          req_age_months: {
            required,
            minValue: minValue(0),
            maxValue: maxValue(
              this.reqAgeMonthMax(this.params.employer_match.req_age_years, 21)
            )
          },
          req_service_years: {
            required,
            minValue: minValue(0),
            maxValue: maxValue(2)
          },
          req_service_months: {
            required,
            minValue: minValue(0),
            maxValue: maxValue(
              this.reqAgeMonthMax(
                this.params.employer_match.req_service_years,
                2
              )
            )
          },
          catch_up_matched: { required },
          yos_vary: { required },
          dollar_limit: { required },
          dollar_limit_amount: { required },
          funding_frequency: { required },
          tiers: {
            required,
            $each: {
              matching_amount: {
                minValue: minValue(0),
                maxValue: maxValue(500)
              },
              deferral_rate: { minValue: minValue(0), maxValue: maxValue(15) },
              contribution_amount: {
                minValue: minValue(0),
                maxValue: maxValue(this.complianceLimits.max_deferral)
              },
              yos_upper_limit: { minValue: minValue(0), maxValue: maxValue(30) }
            }
          }
        },
        employer_other: {
          er_other: { required, minValue: minValue(0), maxValue: maxValue(4) },
          req_age_years: {
            required,
            minValue: minValue(0),
            maxValue: maxValue(21)
          },
          req_age_months: {
            minValue: minValue(0),
            maxValue: maxValue(
              this.reqAgeMonthMax(this.params.employer_other.req_age_years, 21)
            )
          },
          req_service_years: { minValue: minValue(0), maxValue: maxValue(2) },
          req_service_months: {
            minValue: minValue(0),
            maxValue: maxValue(
              this.reqAgeMonthMax(
                this.params.employer_other.req_service_years,
                2
              )
            )
          },
          dollar_limit: { required },
          dollar_limit_amount: {
            maxValue: maxValue(this.complianceLimits.max_contribution_dc_plan)
          },
          flat_dollar_limit: {
            minValue: minValue(0),
            maxValue: maxValue(this.complianceLimits.max_contribution_dc_plan)
          },
          compensation_percent: {
            minValue: minValue(0),
            maxValue: maxValue(25)
          },
          compensation_below_lvl: {
            minValue: minValue(0),
            maxValue: maxValue(15)
          },
          compensation_amount: {
            minValue: minValue(
              this.complianceLimits.social_security_wage_base * 0.2
            ),
            maxValue: maxValue(this.complianceLimits.social_security_wage_base)
          },
          compensation_above_lvl: {
            minValue: minValue(0),
            maxValue: maxValue(15)
          },
          funding_frequency: { required }
        },
        pre_tax_contribution: {
          ytd_dollars: {
            maxValue: maxValue(this.complianceLimits.max_deferral)
          },
          percent: { maxValue: maxValue(1) },
          dollars: {},
          dollars_frequency: { required },
          ytd_catchup_dollars: {
            maxValue: maxValue(this.complianceLimits.catch_up)
          },
          percent_catchup: {},
          dollars_catchup: {
            maxValue: maxValue(this.complianceLimits.catch_up)
          },
          dollars_catchup_frequency: { required },
          opt_out: { required },
          frequency_type: { required },
          annual_percent: { minValue: minValue(0), maxValue: maxValue(0.05) },
          maximum_percent: { minValue: minValue(0), maxValue: maxValue(0.05) },
          frequency1: {},
          frequency2: {}
        },
        roth_contribution: {
          ytd_dollars: {
            maxValue: maxValue(this.complianceLimits.max_deferral)
          },
          percent: { maxValue: maxValue(1) },
          dollars: {},
          dollars_frequency: { required },
          ytd_catchup_dollars: {
            maxValue: maxValue(this.complianceLimits.catch_up)
          },
          percent_catchup: {},
          dollars_catchup: {
            maxValue: maxValue(this.complianceLimits.catch_up)
          },
          dollars_catchup_frequency: { required },
          opt_out: { required },
          frequency_type: {},
          annual_percent: { minValue: minValue(0), maxValue: maxValue(0.05) },
          maximum_percent: { minValue: minValue(0), maxValue: maxValue(0.05) },
          frequency1: {},
          frequency2: {}
        },
        post_tax_contribution: {
          ytd_dollars: {
            maxValue: maxValue(this.complianceLimits.max_contribution_dc_plan)
          },
          dollars: {},
          dollars_frequency: { required },
          percent: { maxValue: maxValue(1) }
        },
        er_matching_contribution_ytd_dollars: {
          maxValue: maxValue(this.complianceLimits.max_contribution_dc_plan)
        },
        er_other_contribution_ytd_dollars: {
          maxValue: maxValue(this.complianceLimits.max_contribution_dc_plan)
        },
        nqdc: {
          ytd_dollars: {},
          percent: { maxValue: maxValue(1) },
          dollars: {},
          balance: {},
          dollars_frequency: { required },
          pension: {}
        },
        compliance_limit: {
          max_deferral: {},
          max_contribution_dc_plan: {},
          max_contribution_db_plan: {},
          max_comp: {},
          catch_up: {},
          hce_comp: {},
          key_ee_comp_officer: {},
          one_percent_owner_comp: {},
          social_security_wage_base: {}
        }
      }
    };
  },
  computed: {
    ...mapGetters(["complianceLimits"])
  },
  mounted() {
    this.fetchComplianceLimits();
  },
  methods: {
    calculate() {
      this.$store.dispatch(this.calcAction, this.params);
    },
    fetchComplianceLimits() {
      this.$store.dispatch(FETCH_COMPLIANCE_LIMITS);
    },
    getValidationClass(field) {
      if (field) {
        return {
          "md-invalid": field.$invalid
        };
      }
    },
    addTier() {
      this.params.employer_match.tiers.push({});
    },
    removeTier(index) {
      this.params.employer_match.tiers.splice(index, 1);
    },
    combinedMax() {
      return Math.max(
        this.params.employee_contribution.post_tax_max,
        this.params.employee_contribution.roth_max,
        this.params.employee_contribution.pre_tax_max
      );
    },
    reqAgeMonthMax(age_years, maxYears) {
      return +age_years === maxYears ? 0 : 12;
    },
    showInputCategory(category) {
      return this.inputCategories.includes(category);
    }
  }
};
</script>
